import React from "react";
import BingoPlayersList from "../components/BingoPlayersList";
import _ from "lodash";

function BadBingo({ bad_bingos, users, timed, countdown, gameParams }) {
  const bad_bingo_params = _.get(gameParams, "5_badbingo");
  const bingo_button = _.get(bad_bingo_params, "bingo_button", "BINGO!");
  const label = _.get(bad_bingo_params, "label", "BAD BINGO!");
  const reasons_label = _.get(bad_bingo_params, "reasons_label", "REASONS:");
  const reasons_list = _.get(bad_bingo_params, "reasons_list");
  const timed_text = _.get(bad_bingo_params, "timed_text", "GAME WILL CONTINUE IN:");
  const untimed_text = _.get(
    bad_bingo_params,
    "untimed_text",
    "GAME WILL CONTINUE WHEN THE HOST CALLS THE NEXT BALL",
  );
  const players_details = users.filter((user) => bad_bingos.includes(user.player_id));
  return (
    <>
      <div className="bingo-called-wrapper bad-bingo-wrapper">
        <div className="bad-bingo-flex">
          <div>
            <h2 className="bad-txt">{label}</h2>
            <div className="bingo-called-users">
              <BingoPlayersList players={players_details} />
            </div>
            <div className="reasons">
              <h2>{reasons_label}</h2>
              <ul>
                {reasons_list.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="game-cont">
            {timed ? (
              <>
                <h4 className="cont-text">{timed_text}</h4>
                <p className="game-sec">{countdown}</p>
              </>
            ) : (
              <h4 className="cont-text">{untimed_text}</h4>
            )}
          </div>
        </div>
      </div>
      <button className="bingo-btn bad-bingo-btn">{bingo_button}</button>
    </>
  );
}

export default BadBingo;
